import { getNotifications } from "../../../lib/notifications.js";
import { AlertTriangleIcon } from "../../icons.js";
import type { WidgetProps } from "../types.js";

export function RemindersWidget({ events }: WidgetProps) {
  const reminders = getNotifications(events);
  if (reminders.length === 0) return null;

  return (
    <section className="rounded-xl border border-amber-200 dark:border-amber-800 bg-amber-50 dark:bg-amber-950/30 p-4 sm:col-span-2">
      <div className="mb-2 flex items-center gap-2">
        <AlertTriangleIcon size={16} className="text-amber-600 dark:text-amber-400" />
        <h2 className="font-semibold text-amber-900 dark:text-amber-200">Reminders</h2>
      </div>
      <ul className="space-y-1 text-sm text-amber-800 dark:text-amber-200">
        {reminders.map((r, i) => (
          <li key={i} className="flex gap-2"><span aria-hidden>•</span><span>{r}</span></li>
        ))}
      </ul>
    </section>
  );
}
